import { OverlayRef } from '@angular/cdk/overlay';
import { Component, Inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { NotificationsOverlayConfig } from './notifications-overlay.service';
import { NOTIFICATIONS_OVERLAY_DATA } from './notifications-overlay.tokens';
import { AppFrameService } from './app-frame.service';
import { ProgressNotification } from './notifications-overlay.types';

@UntilDestroy()
@Component({
  selector: 'hk-notifications-overlay',
  templateUrl: './notifications-overlay.component.html',
  styles: [
    `
      :host {
        border-radius: 0;
        position: relative;
        min-width: 350px;
        max-width: 350px;
      }
    `,
  ],
})
export class NotificationsOverlayComponent {
  constructor(
    public overlayReference: OverlayRef,
    @Inject(NOTIFICATIONS_OVERLAY_DATA) public config: NotificationsOverlayConfig,
    public menu: AppFrameService,
  ) {
    overlayReference.backdropClick().subscribe((__) => {
      this.close();
    });
  }

  get unseenNotifications$() {
    return this.menu.unseenNotifications$.pipe(map((notifications) => notifications.sort(this.sortNotification)));
  }

  get seenNotifications$() {
    return this.menu.seenNotifications$.pipe(map((notifications) => notifications.sort(this.sortNotification)));
  }

  public notification = (item: ProgressNotification) => item;

  close() {
    this.menu.markNotificationsAsSeen();
    this.overlayReference.dispose();
    if (this.config.onClose) this.config.onClose();
  }

  private sortNotification(a: ProgressNotification, b: ProgressNotification): number {
    if (!a._updatedAt) {
      return 1;
    }
    if (!b._updatedAt) {
      return -1;
    }
    return a._updatedAt.diff(b._updatedAt);
  }
}
